import { AppIcon, RawSVG } from 'core/components/icons/icon.type';

export const iconAngleDownLg: AppIcon = {
  svgData: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 10L12 14L16 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' as RawSVG,
  name: 'angle-down-lg',
};
